export const dailyReportByUserId = /* GraphQL */ `
    query CustomDailyReportByUserId($userId: ID!, $sortDirection: ModelSortDirection, $filter: ModelDailyReportFilterInput, $limit: Int, $nextToken: String) {
        dailyReportByUserId(userId: $userId, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
            items {
                id
                submissionDate
                summary
                isCompleted
                anyoneInjured
                qaqcCompleted
                siteSecured
                type
                customerName
                address
                pdfKey

                locationId

                customerId
                customer {
                    id
                    name
                }

                foremanId
                foreman {
                    id
                    name
                }

                userId
                __typename
            }
            nextToken
            __typename
        }
    }
`;

export const dailyReportByForemanId = /* GraphQL */ `
  query CustomDailyReportByForemanId(
    $foremanId: ID!
    $submissionDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDailyReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    dailyReportByForemanId(
      foremanId: $foremanId
      submissionDate: $submissionDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        submissionDate
        summary
        customerName
        type
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        location {
            id
            name
        }

        customerId
        customer {
            id
            name
        }

        media {
            items {
                id
                description
                filename
                mediaType
                dailyReportId
                userId
                sortKey
                __typename
            }
        }

        foremanId
        foreman {
            id
            name
            active
        }

        userId
        createdBy {
            id
            email
            firstName
            lastName
            phoneNumber
            role
            createdAt
            updatedAt
            isNotificationEnabled
            __typename
        }
          __typename
      }
      nextToken
      __typename
    }
  }
`;

export const searchDailyReports = /* GraphQL */ `
  query CustomSearchDailyReports(
    $filter: SearchableDailyReportFilterInput
    $sort: [SearchableDailyReportSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableDailyReportAggregationInput]
  ) {
    searchDailyReports(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        submissionDate
        summary
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        foremanId
        foreman {
            id
            name
            active
        }
        customerId
        customer {
            id
            name
        }
        userId
        type
        customerName
        address
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;

export const timeSheetByLocationId = /* GraphQL */ `
    query CustomTimeSheetByLocationId(
        $locationId: ID!
        $date: ModelStringKeyConditionInput
        $sortDirection: ModelSortDirection
        $filter: ModelTimeSheetFilterInput
        $limit: Int
        $nextToken: String
    ) {
        timeSheetByLocationId(locationId: $locationId, date: $date, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
            items {
                id
                date
                hours
                isApproved
                allApproved
                customerId
                customer {
                    id
                    name
                }
                customers {
                    id
                    name
                }
                foreman {
                    id
                    name
                    email
                    active
                }
                userId
                locationId
                __typename
            }
            nextToken
            __typename
        }
    }
`;

export const timeSheetByUserId = /* GraphQL */ `
    query CustomTimeSheetByUserId($userId: ID!, $sortDirection: ModelSortDirection, $filter: ModelTimeSheetFilterInput, $limit: Int, $nextToken: String) {
        timeSheetByUserId(userId: $userId, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
            items {
                id
                date
                isApproved
                customerId
                userId
                customers {
                   id
                   name
                }
                customer {
                    id
                    name
                }
                foremanId
                __typename
            }
            nextToken
            __typename
        }
    }
`;

export const listDocuments = /* GraphQL */ `
    query CustomListDocuments($id: ID, $filter: ModelDocumentFilterInput, $limit: Int, $nextToken: String, $sortDirection: ModelSortDirection) {
        listDocuments(id: $id, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
            items {
                id
                name
                pdfKey
                summary
                fillable
                createdBy
                createdAt
                updatedBy
                updatedAt
                folder {
                    name
                    parentId
                }
                creator {
                    firstName
                    lastName
                }
                updator {
                    firstName
                    lastName
                }
                __typename
            }
            nextToken
            __typename
        }
    }
`;

export const searchDocuments = /* GraphQL */ `
    query CustomSearchDocuments(
        $filter: SearchableDocumentFilterInput
        $sort: [SearchableDocumentSortInput]
        $limit: Int
        $nextToken: String
        $from: Int
        $aggregates: [SearchableDocumentAggregationInput]
    ) {
        searchDocuments(filter: $filter, sort: $sort, limit: $limit, nextToken: $nextToken, from: $from, aggregates: $aggregates) {
            items {
                id
                name
                pdfKey
                summary
                fillable
                createdBy
                createdAt
                updatedBy
                updatedAt
                creator {
                    firstName
                    lastName
                }
                updator {
                    firstName
                    lastName
                }
                __typename
            }
            nextToken
            total
            aggregateItems {
                name
                result {
                    ... on SearchableAggregateScalarResult {
                        value
                    }
                    ... on SearchableAggregateBucketResult {
                        buckets {
                            key
                            doc_count
                            __typename
                        }
                    }
                }
                __typename
            }
            __typename
        }
    }
`;

export const searchCompletedDocuments = /* GraphQL */ `
  query CustomSearchCompletedDocuments(
    $filter: SearchableCompletedDocumentFilterInput
    $sort: [SearchableCompletedDocumentSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCompletedDocumentAggregationInput]
  ) {
    searchCompletedDocuments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        pdfKey
        draft
        locked
        lockedById
        lockedBy {
            name
        }
        annotations
        templateId
        locationId
        customerId
        customer {
            name
        }
        creator {
            active
            name
        }
        updator {
            active
            name
        }
        createdBy
        createdAt
        updatedBy
        updatedAt
        finalizeAfter
        authors
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;

export const listCompletedDocuments = /* GraphQL */ `
    query CustomListCompletedDocuments(
        $id: ID
        $filter: ModelCompletedDocumentFilterInput
        $limit: Int
        $nextToken: String
        $sortDirection: ModelSortDirection
    ) {
        listCompletedDocuments(id: $id, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
            items {
                id
                pdfKey
                draft
                name
                templateId
                lockedById
                template {
                    name
                    fillable
                }
                creator {
                    firstName
                    lastName
                }
                updator {
                    firstName
                    lastName
                }
                customer {
                    id
                    name
                }
                createdBy
                createdAt
                updatedBy
                updatedAt
                __typename
            }
            nextToken
            __typename
        }
    }
`;

export const completedDocumentByLocationId = /* GraphQL */ `
    query CustomCompletedDocumentByLocationId(
        $locationId: ID!
        $createdAt: ModelStringKeyConditionInput,
        $sortDirection: ModelSortDirection
        $filter: ModelCompletedDocumentFilterInput
        $limit: Int
        $nextToken: String
    ) {
        completedDocumentByLocationId(locationId: $locationId, createdAt: $createdAt, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
            items {
                id
                name
                pdfKey
                draft
                templateId
                lockedById
                template {
                    name
                    fillable
                }
                creator {
                    id
                    name
                    active
                }
                updator {
                    id
                    name
                }
                location {
                    id
                    name
                }
                customer {
                    id
                    name
                }
                foreman {
                    id
                    name
                    active
                }
                locationId
                createdBy
                createdAt
                updatedBy
                updatedAt
                __typename
            }
            nextToken
            __typename
        }
    }
`;

export const newDailyReport = /* GraphQL */ `
    mutation CustomNewDailyReport($input: NewDailyReportInput) {
        newDailyReport(input: $input) {
            id
            submissionDate
            summary
            isCompleted
            anyoneInjured
            qaqcCompleted
            siteSecured
            type
            address
            pdfKey
            customerName
            locationId
            location {
                id
                name
                phoneNumber
                address
                address1
                city
                province
                postalCode
                maxDailyHours
                maxWeeklyHours
                payPeriodStart
                __typename
            }
            foremanId
            foreman {
                id
                locationId
                email
                name
                rate
                __typename
            }
            media {
                items {
                    id
                    filename
                    description
                    mediaType
                    sortKey
                    __typename
                }
                nextToken
            }
            customerId
            customer {
                id
                number
                name
                locationId
                __typename
            }
            userId
            createdBy {
                id
                email
                firstName
                lastName
                phoneNumber
                isNotificationEnabled
                role
                locationId
                crewMemberId
                createdAt
                updatedAt
                __typename
            }
            __typename
        }
    }
`;

export const listDailyReports = /* GraphQL */ `
    query CustomListDailyReports($id: ID, $filter: ModelDailyReportFilterInput, $limit: Int, $nextToken: String, $sortDirection: ModelSortDirection) {
        listDailyReports(id: $id, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
            items {
                id
                submissionDate
                summary
                isCompleted
                anyoneInjured
                qaqcCompleted
                siteSecured
                userId
                pdfKey
                customerId
                customer {
                    name
                }
                __typename
                foreman {
                    name
                    active
                }
                createdBy {
                    firstName
                    lastName
                }
            }
            nextToken
            __typename
        }
    }
`;

export const dailyReportByLocationId = /* GraphQL */ `
    query CustomDailyReportByLocationId(
        $locationId: ID!
        $submissionDate: ModelStringKeyConditionInput
        $sortDirection: ModelSortDirection
        $filter: ModelDailyReportFilterInput
        $limit: Int
        $nextToken: String
    ) {
        dailyReportByLocationId(
            locationId: $locationId
            submissionDate: $submissionDate
            sortDirection: $sortDirection
            filter: $filter
            limit: $limit
            nextToken: $nextToken
        ) {
            items {
                id
                submissionDate
                summary
                isCompleted
                anyoneInjured
                qaqcCompleted
                siteSecured
                userId
                pdfKey
                customerId
                locationId
                type
                customerName
                address
                customer {
                    name
                }
                foremanId
                foreman {
                    id
                    name
                    email
                    active
                }
                createdBy {
                    firstName
                    lastName
                }
                __typename
            }
            nextToken
            __typename
        }
    }
`;

export const dailyReportByCustomerId = /* GraphQL */ `
  query CustomDailyReportByCustomerId(
    $customerId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelDailyReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    dailyReportByCustomerId(
      customerId: $customerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        submissionDate
        summary
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        foremanId
        customerId
        userId
        type
        customerName
        address
        customer {
            name
        }
        foreman {
            id
            name
            email
            active
        }
        createdBy {
            firstName
            lastName
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getDailyReport = /* GraphQL */ `
    query CustomGetDailyReport($id: ID!) {
        getDailyReport(id: $id) {
            id
            submissionDate
            summary
            isCompleted
            anyoneInjured
            qaqcCompleted
            siteSecured
            pdfKey
            type
            address
            customerName
            userId
            createdBy {
                id
                email
                firstName
                lastName
                phoneNumber
                role
                createdAt
                updatedAt
                isNotificationEnabled
                __typename
            }

            media {
                items {
                    id
                    filename
                    description
                    mediaType
                    sortKey
                }
                nextToken
                __typename
            }
            customerId
            customer {
                id
                number
                name
                __typename
            }

            foremanId
            foreman {
                name
                active
            }
            foremanName
            inspectionType
            taskArea
            weather
            correctiveActions {
                action
                dueDate
                assignedTo
                signature
                __typename
            }
            inspectionQuestion
            foremanSignature
            safetySignature
            __typename
        }
    }
`;

export const getTimeSheet = /* GraphQL */ `
    query CustomGetTimeSheet($id: ID!) {
        getTimeSheet(id: $id) {
            id
            date
            isApproved
            hours
            allApproved
            timeEntries {
                nextToken
                items {
                    id
                    date
                    adjustedHours {
                        straightTime
                        overtime
                    }
                    scopeId
                    scope {
                        id
                        name
                    }
                    isApproved
                    locationId
                    location {
                        id
                        name
                    }
                    crewMemberId
                    crewMember {
                        id
                        name
                        rate
                        active
                        rateOverride {
                            rate
                        }
                    }
                    customerId
                    customer {
                        id
                        name
                    }
                    hours
                    status
                    syncStatusMessage
                }
                __typename
            }
            customers {
                id
                name
            }
            customerId
            locationId
            location {
                id
                name
            }
            customer {
                id
                number
                name
                __typename
            }

            foremanId
            foreman {
                id
                name
                active
            }

            userId
            createdBy {
                id
                email
                firstName
                lastName
                phoneNumber
                role
                createdAt
                updatedAt
                isNotificationEnabled
                __typename
            }
            __typename
        }
    }
`;

export const newTimesheet = /* GraphQL */ `
    mutation CustomNewTimesheet($input: NewTimesheetInput) {
        newTimesheet(input: $input) {
            id
            date
            isApproved
            timeEntries {
                items {
                    id
                    date
                    scopeId
                    scope {
                        id
                        name
                    }
                    isApproved
                    locationId
                    location {
                        id
                        name
                    }
                    crewMemberId
                    crewMember {
                        id
                        name
                        rate
                        active
                        rateOverride {
                            rate
                        }
                    }
                    customerId
                    customer {
                        id
                        name
                    }
                    hours
                    adjustedHours {
                        straightTime
                        overtime
                    }
                    status
                    syncStatusMessage
                }
                nextToken
                __typename
            }
            foremanId
            foreman {
                id
                active
                name
            }
            customerId
            customer {
                id
                number
                name
                locationId
                __typename
            }
            customers {
                id
                name
            }
            userId
            createdBy {
                id
                email
                firstName
                lastName
                phoneNumber
                isNotificationEnabled
                role
                locationId
                createdAt
                updatedAt
                __typename
            }
            locationId
            location {
                id
                name
                phoneNumber
                address
                address1
                city
                province
                postalCode
                maxDailyHours
                maxWeeklyHours
                payPeriodStart
                __typename
            }
            hours
            allApproved
            __typename
        }
    }
`;

export const listUsers = /* GraphQL */ `
    query CustomListUsers($id: ID, $filter: ModelUserFilterInput, $limit: Int, $nextToken: String, $sortDirection: ModelSortDirection) {
        listUsers(id: $id, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
            items {
                id
                email
                firstName
                lastName
                phoneNumber
                isNotificationEnabled
                role
                locationId
                location {
                    id
                    name
                }
                crewMemberId
                crewMember {
                    id
                    name
                }
                createdAt
                updatedAt
                __typename
            }
            nextToken
            __typename
        }
    }
`;

export const usersByLocationId = /* GraphQL */ `
  query CustomUsersByLocationId(
    $locationId: ID!
    $role: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByLocationId(
      locationId: $locationId
      role: $role
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        location {
            id
            name
        }
        crewMemberId
        crewMember {
            id
            name
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const searchUsers = /* GraphQL */ `
    query CustomSearchUsers(
        $filter: SearchableUserFilterInput
        $sort: [SearchableUserSortInput]
        $limit: Int
        $nextToken: String
        $from: Int
        $aggregates: [SearchableUserAggregationInput]
    ) {
        searchUsers(filter: $filter, sort: $sort, limit: $limit, nextToken: $nextToken, from: $from, aggregates: $aggregates) {
            items {
                id
                email
                firstName
                lastName
                phoneNumber
                isNotificationEnabled
                role
                locationId
                location {
                    id
                    name
                }
                crewMemberId
                crewMember {
                    id
                    name
                    active
                }
                createdAt
                updatedAt
                __typename
            }
            nextToken
            total
            aggregateItems {
                name
                result {
                    ... on SearchableAggregateScalarResult {
                        value
                    }
                    ... on SearchableAggregateBucketResult {
                        buckets {
                            key
                            doc_count
                            __typename
                        }
                    }
                }
                __typename
            }
            __typename
        }
    }
`;

export const sessionByLocationId = /* GraphQL */ `
    query CustomSessionByLocationId(
        $locationId: ID!
        $expiry: ModelIntKeyConditionInput
        $sortDirection: ModelSortDirection
        $filter: ModelSessionFilterInput
        $limit: Int
        $nextToken: String
    ) {
        sessionByLocationId(locationId: $locationId, expiry: $expiry, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
            items {
                id
                locationId
                expiry
                createdAt
                tasks {
                    items {
                        id
                        task
                        status
                        createdAt
                    }
                }
                __typename
            }
            nextToken
            __typename
        }
    }
`;
export const completedDocumentByCrewMemberId = /* GraphQL */ `
  query CustomCompletedDocumentByCrewMemberId(
    $createdBy: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompletedDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    completedDocumentByCrewMemberId(
      createdBy: $createdBy
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        pdfKey
        draft
        templateId
        lockedById
        template {
            name
            fillable
        }
        creator {
            id
            name
            active
        }
        updator {
            id
            name
        }
        location {
            id
            name
        }
        customer {
            id
            name
        }
        foreman {
            id
            name
            active
        }
        locationId
        createdBy
        createdAt
        updatedBy
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const completedDocumentByForemanId = /* GraphQL */ `
  query CustomCompletedDocumentByForemanId(
    $foremanId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompletedDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    completedDocumentByForemanId(
      foremanId: $foremanId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        pdfKey
        draft
        templateId
        lockedById
        template {
            name
            fillable
        }
        creator {
            id
            name
            active
        }
        updator {
            id
            name
        }
        location {
            id
            name
        }
        customer {
            id
            name
        }
        foreman {
            id
            name
            active
        }
        locationId
        createdBy
        createdAt
        updatedBy
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const completedDocumentByCustomerId = /* GraphQL */ `
  query CustomCompletedDocumentByCustomerId(
    $customerId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCompletedDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    completedDocumentByCustomerId(
      customerId: $customerId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        pdfKey
        draft
        templateId
        lockedById
        template {
            name
            fillable
        }
        creator {
            id
            name
            active
        }
        updator {
            id
            name
        }
        location {
            id
            name
        }
        customer {
            id
            name
        }
        foreman {
            id
            name
            active
        }
        locationId
        createdBy
        createdAt
        updatedBy
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listLocations = /* GraphQL */ `
  query CustomListLocations(
    $id: ID
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLocations(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        mediaTargetFilesize
        mediaCompression
        supportURL
        termsOfUseURL
        privacyURL
        syncTasks
        __typename
        dailyTimeReportReceivers {
            email
            __typename
        }
      }
      nextToken
      __typename
    }
  }
`;

export const groupByLocationId = /* GraphQL */ `
  query CustomGroupByLocationId(
    $locationId: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    groupByLocationId(
      locationId: $locationId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        locationId
        createdAt
        crewMemberIds
        members {
            id
            active
            name
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchGroups = /* GraphQL */ `
  query CustomSearchGroups(
    $filter: SearchableGroupFilterInput
    $sort: [SearchableGroupSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableGroupAggregationInput]
  ) {
    searchGroups(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        locationId
        createdAt
        crewMemberIds
        division
        members {
            id
            active
            name
        }
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;

export const updateTimeEntry = /* GraphQL */ `
  mutation CustomUpdateTimeEntry(
    $input: UpdateTimeEntryInput!
    $condition: ModelTimeEntryConditionInput
  ) {
    updateTimeEntry(input: $input, condition: $condition) {
      id
      date
      scopeId
      scope {
        id
        name
        fullName
        account
        active
        locationId
        __typename
      }
      hours
      adjustedHours {
        straightTime
        overtime
        __typename
      }
      isApproved
      timeSheetId
      timeSheet {
        id
        locationId
        customerId
        foremanId
        userId
        hours
        allApproved
        date
        isApproved
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      crewMemberId
      crewMember {
        id
        active
        locationId
        email
        name
        rate
        rateOverride {
            rate
        }
        crewMemberUserId
        __typename
      }
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        __typename
      }
      status
      syncStatusMessage
      __typename
    }
  }
`;